import { STATUS_CFG } from "./constants";
import { BadgeTypes } from "./types";

export default function StatusBadge({ status }: { status: BadgeTypes }) {
    const cfg = STATUS_CFG[status];
    return (
        <span 
             style={{ display: "inline-flex", alignItems: "center", gap: 5, fontSize: 11, fontWeight: 600, letterSpacing: "0.4px", background: cfg.bg, border: `1px solid ${cfg.border}`, color: cfg.color, borderRadius: 20, padding: "3px 9px", whiteSpace: "nowrap" }}>
            <span 
              style={{ width: 5, height: 5, borderRadius: "50%", background: cfg.color, flexShrink: 0 }} />
            {cfg.label}
        </span>
    );
}